import { faArchive, faBell, faBriefcaseMedical, faCarSide, faRoute, faSearch, faUserFriends, faUserTie, faWrench } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { connect } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import Select from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";
import { Card, CardBody, CardTitle, Col, Container, Row, Modal, ModalBody, ModalFooter, ModalHeader, Label, Button } from "reactstrap";
import instance from "../../axiosInstance";
import { useProfileContext } from "../../context/profile";
import useError from "../../hooks/useError";
import Header from "../UI/Header";
import HeaderSubtitle from "../UI/HeaderSubtitle";
import HeaderTitle from "../UI/HeaderTitle";
import { months, years } from "../UI/forms/CustomDate";
import PendingHireTable from "./Tables/PendingHireTable";
import PendingLeadSourceTable from "./Tables/PendingLeadSourceTable";
import NewLeadSourceTable from "./Tables/NewLeadSourceTable";
import PendingLeadSourceTableForHire from "./Tables/PendingLeadSourceTableForHire";
import PendingPanelTable from "./Tables/PendingPanelTable";
import ReactApexChart from 'react-apexcharts';
import NewHireTable from "./Tables/NewHireTable";
import PersonalNotes from "./PersonalNotes";
import moment from "moment";
import SalesSection from "./SalesSection";

// Add blinking animation styles
const blinkStyle = {
  animation: 'blink 1s linear infinite',
};

const style = document.createElement('style');
style.textContent = `
  @keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  }
`;
document.head.appendChild(style);

export const loadFileHandlerOptions = async (search, loadedOptions, { page }) => {
  try {
    const res = await instance.get("/lookups/fileHandlers", {
      params: { search, page, limit: 10 },
    });

    const { data } = res.data;
    const options = data.data.map((role) => ({
      value: role.user_id,
      label: role.full_name,
    }));

    return {
      options,
      hasMore: page < data.total_pages,
      additional: {
        page: page + 1,
      },
    };
  } catch (error) {
    return {
      options: [],
      hasMore: false,
    };
  }
};

const CaseCard = ({ title, value, onClick, icon, iconClick, classesName }) => {
  const handleIconClick = (e) => {
    e.stopPropagation();
    if (iconClick) {
      iconClick(e);
    }
  };

  return (
    <Card className={`cursor-pointer px-4 pt-2 ${classesName}`} onClick={onClick}>
      <div className="d-flex justify-content-center mb-2" onClick={handleIconClick}>
        <FontAwesomeIcon icon={icon} size="lg" />
      </div>
      <CardTitle className="d-flex align-items-center justify-content-between">
        <span>{title}</span> <span>{value || 0}</span>
      </CardTitle>
    </Card>
  );
};

const CaseCardLarge = ({ title, value, title2, value2, title3, value3, onClick, icon, iconClick, classesName }) => {
  const handleIconClick = (e) => {
    e.stopPropagation();
    if (iconClick) {
      iconClick(e);
    }
  };

  return (
    <Card className={`cursor-pointer px-4 pt-2 ${classesName}`} onClick={onClick}>
      <div className="d-flex justify-content-center mb-2" onClick={handleIconClick}>
        <FontAwesomeIcon icon={icon} size="lg" />
      </div>
      <CardTitle className="d-flex align-items-center justify-content-between">
        <span>{title}</span> <span>{value || 0}</span>
      </CardTitle>

      <CardTitle className="d-flex align-items-center justify-content-between">
        <span>{title2}</span> <span>{value2 || 0}</span>
      </CardTitle>
      {
        title3 ? (

          <CardTitle className="d-flex align-items-center justify-content-between">
            <span>{title3}</span> <span>{value3 || 0}</span>
          </CardTitle>
        ) : (
          <></>
        )
      }
    </Card>
  );
};


export const selectHideArrowStyle = {
  dropdownIndicator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
};

const AdminDashboard = ({ theme }) => {
  const { handleError } = useError();
  const history = useHistory();
  const { profile } = useProfileContext();
  const [dashboardInfo, setDashboardInfo] = useState(null);
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCasesModalOpen, setIsCasesModalOpen] = useState(false);
  const [selectedCases, setSelectedCases] = useState([]);
  const [selectedIntroducer, setSelectedIntroducer] = useState('');
  const date = new Date();

  const selectedYear = sessionStorage.getItem("admin-selectedYear");
  const selectedMonth = sessionStorage.getItem("admin-selectedMonth");
  const selectedFileHandler = sessionStorage.getItem("admin-selectedFileHandler");
  const [month, setMonth] = useState(selectedMonth ? { value: +selectedMonth, label: months[+selectedMonth - 1] } : { value: date.getMonth() + 1, label: months[date.getMonth()] });
  const [year, setYear] = useState(selectedYear ? { value: selectedYear, label: selectedYear } : { value: date.getFullYear(), label: date.getFullYear() });
  const [fileHandler, setFileHandler] = useState(selectedFileHandler ? JSON.parse(selectedFileHandler) : null);

  // const getTotal = () => {
  //   let total = 0;

  //   total += dashboardInfo?.data_total?.total_pi ? +dashboardInfo?.data_total?.total_pi : 0;
  //   total += dashboardInfo?.data_total?.total_hire ? +dashboardInfo?.data_total?.total_hire : 0;
  //   total += dashboardInfo?.data_total?.total_repair ? +dashboardInfo?.data_total?.total_repair : 0;
  //   total += dashboardInfo?.data_total?.total_storage ? +dashboardInfo?.data_total?.total_storage : 0;
  //   total += dashboardInfo?.data_total?.total_recovery ? +dashboardInfo?.data_total?.total_recovery : 0;
  //   total += dashboardInfo?.data_total?.total_inspection ? +dashboardInfo?.data_total?.total_inspection : 0;

  //   return total;
  // };

  const data = {
    labels: dashboardInfo?.data_current?.map((d) => d.label) || ["Generates", "Rejected", "Transfers", "Pack", "Bikes"],
    datasets: [
      {
        data: dashboardInfo?.data_current?.map((d) => d.total) || [],
        backgroundColor: ["#153d77", theme.primary, theme.warning, theme.danger, "#E8EAED"],
        borderColor: "transparent",
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    legend: {
      position: "left",
      labels: {
        usePointStyle: true,
      },
    },
    tooltips: {
      intersect: false,
    },
  };

  useEffect(() => {
    (async function () {
      try {
        const { data } = await instance.get("/dashboard/admin", {
          params: {
            current_year: year?.value || null,
            current_month: month?.value || null,
            file_handler_id: fileHandler?.value || "",
          },
        });
        setDashboardInfo(data.data);
      } catch (error) {
        handleError(error);
      }
    })();
  }, [fileHandler?.value, month?.value, year?.value]);

  const handleCaseClick = (caseName) => {
    const startMonth = month ? String(month.value).padStart(2, "0") : "01";
    const lastMonth = month ? String(month.value).padStart(2, "0") : "12";
    const firstDate = `${year?.value || date.getFullYear()}-${startMonth}-01`;
    const lastDate = `${year?.value || date.getFullYear()}-${lastMonth}-${moment().endOf('month').format('DD')}`;

    window.open(`/reports/${caseName}?first_date=${firstDate}&last_date=${lastDate}${fileHandler ? `&file_handler=${JSON.stringify([fileHandler.value, fileHandler.label])}` : ""}`, "_blank");
  };

  const handlePIStatusClick = (status) => {
    const startMonth = month ? String(month.value).padStart(2, "0") : "01";
    const lastMonth = month ? String(month.value).padStart(2, "0") : "12";
    const firstDate = `${year?.value || date.getFullYear()}-${startMonth}-01`;
    const lastDate = `${year?.value || date.getFullYear()}-${lastMonth}-${moment().endOf('month').format('DD')}`;

    window.open(`/administration/cases?service_type=Personal+Injury&case_status=${status}&from_date=${firstDate}&to_date=${lastDate}`, "_blank");
  };



  useEffect(() => {
    if (dashboardInfo) {
      const categories = Object.values(dashboardInfo.topIntroducers).map(item => item.introducer);

      const seriesData = Object.values(dashboardInfo.topIntroducers).map(item => parseInt(item.cases?.length || 0));

      const colors = ['#153d77', theme.primary, theme.warning, theme.danger, '#02580F', '#58024C', '#34495e'];

      const options = {
        chart: {
          type: 'bar',
          height: 320,
          events: {
            click: function (event, chartContext, config) {
              if (config.dataPointIndex >= 0) {
                const cases = Object.values(dashboardInfo.topIntroducers)[config.dataPointIndex].cases || null;
                const introducer = categories[config.dataPointIndex];

                if (cases && cases.length > 0) {
                  setSelectedCases(cases);
                  setSelectedIntroducer(introducer);
                  setIsCasesModalOpen(true);
                }
              }
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
            barHeight: '90%',
            dataLabels: {
              position: 'center',
              style: {
                cursor: 'pointer',
                padding: 30
              }
            }
          }
        },
        colors: colors,
        dataLabels: {
          enabled: true
        },
        xaxis: {
          categories: categories,
        },
        legend: {
          show: false
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: function (value) {
              return value;
            }
          }
        }
      };

      const series = [{
        name: 'Introducers',
        data: seriesData
      }];

      setChartOptions(options);
      setChartSeries(series);
    }
  }, [dashboardInfo]);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleCasesModal = () => {
    setIsCasesModalOpen(!isCasesModalOpen);
  };

  return (
    <>
      <Container fluid>
        <Header>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <HeaderTitle>Welcome, {profile?.full_name}</HeaderTitle>
              <HeaderSubtitle className="d-flex align-items-center">
                <span className="fs-18 mr-4">Total Cases: <span className="fs-22">{dashboardInfo?.data_total?.total}</span></span>

              </HeaderSubtitle>
            </div>
            <div className="d-flex">
              <AsyncPaginate
                styles={{
                  menu: (base) => ({
                    ...base,
                    maxHeight: 150,
                    overflowY: 'auto',
                    scrollBehavior: 'smooth',
                    WebkitOverflowScrolling: 'touch',
                  }),
                  menuList: (base) => ({
                    ...base,
                    maxHeight: 150,
                    overflowY: 'auto',
                  }),
                }}
                className="basic-single w-180 mr-3"
                classNamePrefix="select"
                isSearchable={true}
                placeholder="File Handler"
                name="fileHandler"
                id="fileHandler"
                loadOptions={loadFileHandlerOptions}
                value={fileHandler}
                isClearable
                additional={{
                  page: 1,
                }}
                debounceTimeout={300}
                onChange={(selected) => {
                  setFileHandler(selected);
                  selected ? sessionStorage.setItem("admin-selectedFileHandler", JSON.stringify(selected)) : sessionStorage.removeItem("admin-selectedFileHandler");
                }}
              />
              <Select
                className="basic-single w-120 mr-3"
                classNamePrefix="select"
                placeholder="Month"
                isClearable
                styles={selectHideArrowStyle}
                value={month}
                onChange={(selectedOption) => {
                  setMonth(selectedOption);
                  selectedOption ? sessionStorage.setItem("admin-selectedMonth", selectedOption.value) : sessionStorage.removeItem("admin-selectedMonth");
                }}
                options={months.map((month, index) => ({ value: index + 1, label: month }))}
              />
              <Select
                className="basic-single w-120"
                classNamePrefix="select"
                placeholder="Year"
                styles={selectHideArrowStyle}
                value={year}
                onChange={(selectedOption) => {
                  setYear(selectedOption);
                  selectedOption ? sessionStorage.setItem("admin-selectedYear", selectedOption.value) : sessionStorage.removeItem("admin-selectedYear");
                }}
                options={years.map((year) => ({ value: year, label: year }))}
              />
            </div>
          </div>
        </Header>

        <div className="w-100">
          <Row>
            <Col sm="2">
              <CaseCardLarge iconClick={() => setIsModalOpen(true)} title="PI" value={dashboardInfo?.data_total?.total_pi} onClick={() => handleCaseClick("PIreport")} icon={faBriefcaseMedical} value2={dashboardInfo?.data_pi?.total_pack} title2="Pack" />

            </Col>
            <Col sm="2">
              <CaseCardLarge title="Hire" value={dashboardInfo?.data_total?.total_hire} onClick={() => handleCaseClick("hireReport")} icon={faCarSide} value2={dashboardInfo?.data_hire?.total_on_hire} title2="On Hire" />

            </Col>
            <Col sm="2">
              <CaseCardLarge title="Repair" value={dashboardInfo?.data_total?.total_repair} onClick={() => handleCaseClick("repairReport")} icon={faWrench} value2={dashboardInfo?.data_completed_repair?.total_complete} title2="Completed" />
            </Col>
            <Col sm="2">
              <CaseCard title="Storage" value={dashboardInfo?.data_total?.total_storage} onClick={() => handleCaseClick("storageReport")} icon={faArchive} />
            </Col>
            <Col sm="2">
              <CaseCard title="Recovery" value={dashboardInfo?.data_total?.total_recovery} onClick={() => handleCaseClick("recoveryReport")} icon={faRoute} />
            </Col>
            <Col sm="2">
              <CaseCard title="Inspection" value={dashboardInfo?.data_total?.total_inspection} icon={faSearch} />
            </Col>
          </Row>
        </div>

        <div className="w-100">
          <Card>
            <CardBody>
              <h4 className="fs-22">Daily Statistics</h4>
              <Row className="align-items-center">
                <Col sm="6">
                  <div>
                    <Pie data={data} options={options} />
                  </div>
                </Col>
                <Col sm="6">
                  <div>
                    <ReactApexChart
                      options={chartOptions}
                      series={chartSeries}
                      type="bar"
                      height={220}
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>

        <SalesSection />

        <div className="w-100">
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between align-items-center pb-2">
                <h4 className="fs-22">Action required for PI cases. </h4>
                <FontAwesomeIcon icon={faBell} size="2x" />
              </div>
              <Row>
                <Col sm="6">
                  <Card className="border">
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <h5 className="my-2 mr-2">New PI Cases</h5>
                        <FontAwesomeIcon icon={faUserTie} size="lg" />
                      </div>
                      <NewLeadSourceTable year={year} month={month} fileHandler={fileHandler} />
                    </CardBody>
                  </Card>
                </Col>
                <Col sm="6">
                  <Card className="border">
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <h5 className="my-2 mr-2">Pending Panel</h5>
                        <FontAwesomeIcon icon={faUserFriends} size="lg" />
                      </div>
                      <PendingPanelTable year={year} month={month} fileHandler={fileHandler} />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>

        <div className="w-100">
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between align-items-center pb-2">
                <h4 className="fs-22">Action required for Hire cases.</h4>
                <FontAwesomeIcon icon={faBell} size="2x" />
              </div>
              <Row>
                <Col sm="6">
                  <Card className="border">
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <h5 className="my-2 mr-2">Pending Lead Source</h5>
                        <FontAwesomeIcon icon={faUserTie} size="lg" />
                      </div>
                      <PendingLeadSourceTableForHire year={year} month={month} fileHandler={fileHandler} />
                    </CardBody>
                  </Card>
                </Col>
                <Col sm="6">
                  <Card className="border">
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <h5 className="my-2 mr-2">New Hire</h5>
                        <FontAwesomeIcon icon={faCarSide} size="lg" />
                      </div>
                      <NewHireTable year={year} month={month} fileHandler={fileHandler} />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Col>
            <PersonalNotes />
          </Col>
        </div>
      </Container>

      <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
        <ModalHeader>Choose a Record</ModalHeader>
        <ModalBody className='bg-dark'>

          <div className="w-100 mt-5">
            <Row>
              <Col sm="3">
                <CaseCard title="Total PI" value={dashboardInfo?.data_total?.total_pi || 0} onClick={() => handlePIStatusClick("")} icon={faBriefcaseMedical} />
              </Col>
              <Col sm="3">
                <CaseCard title="New Cases" value={dashboardInfo?.data_pi?.total_new} onClick={() => handlePIStatusClick("New")} icon={faArchive} />
              </Col>
              <Col sm="3">
                <CaseCard title="Pending Cases" value={dashboardInfo?.data_pi?.total_pending} onClick={() => handlePIStatusClick("Pending")} icon={faArchive} />
              </Col>
              <Col sm="3">
                <CaseCard title="Accepted Cases" value={dashboardInfo?.data_pi?.total_accept} onClick={() => handlePIStatusClick("Accept")} icon={faArchive} />
              </Col>
              <Col sm="3">
                <CaseCard title="Rejected Cases" value={dashboardInfo?.data_pi?.total_reject} onClick={() => handlePIStatusClick("Reject")} icon={faArchive} />
              </Col>
              <Col sm="3">
                <CaseCard title="Pack Cases" value={dashboardInfo?.data_pi?.total_pack} onClick={() => handlePIStatusClick("Pack")} icon={faArchive} />
              </Col>
              <Col sm="3">
                <CaseCard title="Clawback Cases" value={dashboardInfo?.data_pi?.total_claw_back} onClick={() => handlePIStatusClick("Clawback")} icon={faArchive} />
              </Col>
              <Col sm="3">
                <CaseCard title="OnHold Cases" value={dashboardInfo?.data_pi?.total_on_hold} onClick={() => handlePIStatusClick("ON+HOLD")} icon={faArchive} />
              </Col>
              <Col sm="3">
                <CaseCard title="RollBack Cases" value={dashboardInfo?.data_pi?.total_rollback} onClick={() => handlePIStatusClick("Rollback")} icon={faArchive} />
              </Col>
              <Col sm="3">
                <CaseCard title="Signup Cases" value={dashboardInfo?.data_pi?.total_signup} onClick={() => handlePIStatusClick("Signup")} icon={faArchive} />
              </Col>
              <Col sm="3">
                <CaseCard title="Hire Only Cases" value={dashboardInfo?.data_pi?.total_hire_only} onClick={() => handlePIStatusClick("Hire+Only")} icon={faArchive} />
              </Col>
              <Col sm="3">
                <CaseCard title="Retained Cases" value={dashboardInfo?.data_pi?.total_retained} onClick={() => handlePIStatusClick("Retained")} icon={faArchive} />
              </Col>
            </Row>
          </div>

        </ModalBody>
        <ModalFooter>
          <Button color="primary" outline onClick={toggleModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={isCasesModalOpen} toggle={toggleCasesModal} size="lg" centered>
        <ModalHeader toggle={toggleCasesModal}>
          Cases for {selectedIntroducer} (Total: {selectedCases?.length})
        </ModalHeader>
        <ModalBody>
          {selectedCases.length > 0 ? (
            <div className="table-responsive" style={{ maxHeight: "70vh", overflowY: "auto" }}>
              <table className="table table-bordered table-striped">
                <thead>
                  <tr >
                    <th style={{ position: "sticky", top: 0, backgroundColor: "white" }}>S.no</th>
                    <th style={{ position: "sticky", top: 0, backgroundColor: "white" }}>Case ID</th>
                    <th style={{ position: "sticky", top: 0, backgroundColor: "white" }}>Case Type</th>
                    <th style={{ position: "sticky", top: 0, backgroundColor: "white" }}>Lead Source</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedCases.map((caseItem, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td><Link target="_blank" to={`/administration/cases/${caseItem.case_id}/edit`}>{caseItem.case_id}</Link></td>
                      <td>{caseItem.case_type || 'N/A'}</td>
                      <td>{caseItem.lead_source || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center p-3">
              <p>No cases found for this introducer.</p>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleCasesModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

    </>
  );
};

export default connect((store) => ({
  theme: store.theme.currentTheme,
}))(AdminDashboard);
